import React, { useEffect, useState } from "react";
import CartApiService from "../services/CartApiService";
import { Card, Typography, Tag, Button, Row, Col, Radio, Divider, message } from "antd";
import { FileTextOutlined, BookOutlined, BankOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Role } from "../constants/Role";
import "../styles/Checkout.css";

const { Title, Text } = Typography;



const Checkout = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payment, setPayment] = useState("vnpay");
  const navigate = useNavigate();
  const { hasAnyRole } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Chỉ fetch cart cho role LEARNER
        if (!hasAnyRole([Role.LEARNER])) {
          setCourses([]);
          setLoading(false);
          return;
        }
        
        const selectedIds = JSON.parse(localStorage.getItem('selectedCourseIds') || '[]');
        const cartRes = await CartApiService.getCart();
        const cartCourses = cartRes.data?.courses || [];
        // Lọc lại chỉ lấy các khóa học đã chọn
        const filtered = cartCourses.filter(c => selectedIds.includes(c._id));
        setCourses(filtered);
      } catch (e) {
        message.error('Không thể tải thông tin đơn hàng');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [hasAnyRole]);

  const totalAmount = courses.reduce((sum, c) => sum + c.price, 0);

  const handlePayment = async () => {
    // Chỉ cho phép role LEARNER thanh toán
    if (!hasAnyRole([Role.LEARNER])) {
      message.warning('Only learners can checkout!');
      return;
    }
    
    try {
      const selectedIds = courses.map(c => c._id);
      const res = await CartApiService.checkout(selectedIds);
      if (res && res.data && res.data.payment.paymentUrl) {
        localStorage.removeItem('selectedCourseIds');
        window.location.href = res.data.payment.paymentUrl;
      } else {
        message.error('Không lấy được link thanh toán!');
      }
    } catch (e) {
      message.error('Thanh toán thất bại!');
    }
  };

  return (
    <div className="checkout-bg">
      <div className="checkout-container">
        <Title level={2} style={{ marginBottom: 0 }}>Checkout</Title>
        <Text type="secondary" className="checkout-subtitle">
          Complete your order
        </Text>
        <Row gutter={[32, 0]} align="top">
          {/* Left: Course List */}
          <Col xs={24} md={16}>
            <Card className="checkout-item-card" loading={loading}>
              <Title level={4} style={{ marginBottom: 24 }}>
                Order information ({courses.length} courses)
              </Title>
              {courses.map((course) => (
                <Card
                  key={course._id}
                  className="checkout-item-card"
                  bodyStyle={{ display: "flex", alignItems: "center", padding: 24, border: 0 }}
                  style={{ marginBottom: 20 }}
                >
                  <div className="checkout-img-box">
                    <img src={course.imageUrl} alt="course" className="checkout-img" />
                  </div>
                  <div style={{ flex: 1, marginLeft: 24 }}>
                    <Title level={5} className="checkout-course-name">{course.name}</Title>
                    <Text type="secondary" style={{ fontSize: 15 }}>By {course.author}</Text>
                    <div className="checkout-item-tags">
                      {/* Có thể thêm tag nếu cần */}
                    </div>
                    <Text type="secondary" className="checkout-item-meta">
                      <span style={{ marginRight: 16, display: 'inline-flex', alignItems: 'center', color: 'black' }}>
                        <FileTextOutlined style={{ marginRight: 4, fontSize: 16, color: '#1677ff' }} />
                        {course.sectionCount} Sections
                      </span>
                      <span style={{ marginRight: 16, display: 'inline-flex', alignItems: 'center', color: 'black'}}>
                        <BookOutlined style={{ marginRight: 4, fontSize: 16, color: '#1677ff' }} />
                        {course.lessonCount} Lessons
                      </span>
                    </Text>
                  </div>
                  <div style={{ minWidth: 120, textAlign: "right", display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <Text strong style={{ color: "black", fontSize: 20, display: 'flex', alignItems: 'center' }}>
                      ${course.price.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                      
                    </Text>
                  </div>
                </Card>
              ))}
            </Card>
          </Col>
          {/* Right: Order Summary & Payment */}
          <Col xs={24} md={8}>
            <Card className="checkout-summary-card" loading={loading}>
              <Title level={5} style={{ marginBottom: 16 }}>Order Summary</Title>
              <div style={{ marginBottom: 8 }}>
                <Text type="secondary">Subtotal:</Text>
                <span style={{ float: "right" }}>${totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
              </div>
              <div className="checkout-summary-total">
                Total: ${totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </div>
              <Button type="primary" block size="large" style={{ background: "linear-gradient(90deg,#722ed1,#1677ff)", marginBottom: 16 }} onClick={handlePayment} disabled={courses.length === 0}>
                Payment
              </Button>
              <Divider style={{ margin: "16px 0" }} />
              <div style={{ marginBottom: 8, fontWeight: 500 }}>Choose payment method:</div>
              <Radio.Group value={payment} onChange={e => setPayment(e.target.value)} style={{ width: "100%" }}>
                <div className={`checkout-radio-option${payment === 'vnpay' ? ' selected' : ''}`} onClick={() => setPayment('vnpay')}>
                  <Radio value="vnpay" style={{ marginRight: 12 }} />
                  <img src="https://vnpay.vn/s1/statics.vnpay.vn/2023/6/0oxhzjmxbksr1686814746087.png" alt="VNPAY" style={{ height: 36, marginRight: 12,marginLeft:10, background: '#fff', borderRadius: 6, padding: 2 }} />
                  <span style={{ fontWeight: 500, color: '#111' }}>VNPAY</span>
                  <span style={{ color: "black", marginLeft: 10, fontSize: 13, fontWeight: '600' }}>Pay via VNPAY</span>
                </div>
                {/* <div className={`checkout-radio-option${payment === 'other' ? ' selected' : ''}`} onClick={() => setPayment('other')}>
                  <Radio value="other" style={{ marginRight: 12 }} />
                  <span style={{ background: "#fff", color: "#1677ff", borderRadius: 6, padding: "4px 14px", fontWeight: 700, marginRight: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <BankOutlined style={{ fontSize: 28, color: '#a3a3a3' }} />
                  </span>
                  <span style={{ fontWeight: 500, color: '#111' }}>Other Bank</span>
                  <span style={{ color: "#888", marginLeft: 8, fontSize: 13 }}>Coming soon</span>
                </div> */}
              </Radio.Group>
              <div style={{ color: "#888", fontSize: 13, marginTop: 16 }}>
                By completing your order, you agree to our <a href="#" style={{ color: "#1677ff" }}>Terms of Service</a>.
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Checkout; 